export const termsContent = {
  title: 'Términos y Condiciones',
  lastUpdated: 'Junio 2026',
  sections: [
    {
      heading: '1. Naturaleza del Servicio',
      text: 'DushiTarot Videncial ofrece servicios de lectura de tarot y videncia con fines de entretenimiento, orientación personal y reflexión. Al utilizar nuestros servicios, usted comprende y acepta que las lecturas no garantizan resultados específicos y están sujetas a su propia interpretación.',
    },
    {
      heading: '2. No Sustituye Asesoramiento Profesional',
      text: 'Nuestras consultas no reemplazan, bajo ninguna circunstancia, el asesoramiento profesional médico, psicológico, legal, financiero o psiquiátrico. Si requiere asistencia en estas áreas, le recomendamos acudir a un profesional cualificado.',
    },
    {
      heading: '3. Mayoría de Edad',
      text: 'Para solicitar y participar en nuestras consultas, usted debe ser mayor de 18 años. Al contactarnos, usted confirma que cumple con este requisito legal.',
    },
    {
      heading: '4. Pagos y Reservas',
      text: 'Todas las reservas, coordinaciones y pagos se gestionan exclusivamente a través de nuestro canal oficial de WhatsApp. Los detalles específicos sobre tarifas y métodos de pago se proporcionarán de manera privada antes de confirmar su sesión.',
    },
    {
      heading: '5. Conducta y Respeto',
      text: 'Nos reservamos el derecho de rechazar o finalizar cualquier consulta si detectamos un comportamiento inapropiado, ofensivo, amenazante o que vulnere el respeto mutuo.',
    },
    {
      heading: '6. Limitación de Responsabilidad',
      text: 'DushiTarot Videncial, sus lectores y afiliados no se hacen responsables por las decisiones, acciones o consecuencias que el cliente tome basándose en la información proporcionada durante la consulta. Usted es el único responsable de su vida y sus decisiones.',
    },
    {
      heading: '7. Modificaciones',
      text: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado de nuestros servicios tras cualquier cambio constituye la aceptación de los nuevos términos.',
    },
  ],
}

export const privacyContent = {
  title: 'Política de Privacidad',
  lastUpdated: 'Junio 2026',
  sections: [
    {
      heading: '1. Información que Recopilamos',
      text: 'Al interactuar con nosotros, podemos recopilar información personal básica como su nombre, número de teléfono (WhatsApp) y los mensajes o detalles que usted decida compartir voluntariamente para llevar a cabo la consulta.',
    },
    {
      heading: '2. Uso de la Información',
      text: 'Utilizamos sus datos personales exclusivamente para coordinar, agendar y realizar las consultas solicitadas, así como para mantener comunicación directa relacionada con nuestros servicios.',
    },
    {
      heading: '3. Tecnologías de Seguimiento y Meta Pixel',
      text: 'Nuestro sitio web utiliza Meta Pixel y cookies similares para medir las visitas a la página y los clics en los botones de contacto de WhatsApp. Esto nos ayuda a entender cómo interactúan los usuarios con nuestro sitio y a optimizar nuestras campañas publicitarias. Esta información se procesa de forma agregada a través de los servicios de Meta (Facebook).',
    },
    {
      heading: '4. Compartir Información con Terceros',
      text: 'No vendemos, alquilamos ni compartimos su información personal con terceros para fines de marketing. Su información solo se comparte con plataformas de comunicación (WhatsApp) y análisis (Meta) estrictamente para el funcionamiento del servicio y la medición del sitio.',
    },
    {
      heading: '5. Retención de Datos',
      text: 'Conservamos su información únicamente durante el tiempo necesario para cumplir con los propósitos descritos en esta política, o según lo exija la ley.',
    },
    {
      heading: '6. Sus Derechos',
      text: 'Usted tiene derecho a solicitar el acceso, rectificación o eliminación de sus datos personales en cualquier momento. Para ejercer estos derechos, simplemente envíenos un mensaje a través de nuestro número oficial de WhatsApp.',
    },
    {
      heading: '7. Consentimiento',
      text: 'Al utilizar nuestro sitio web y contactarnos vía WhatsApp, usted consiente la recopilación y uso de su información de acuerdo con esta Política de Privacidad.',
    },
  ],
}
